export const clientId = process.env.REACT_APP_CLIENT_ID || ""
export const authority = process.env.REACT_APP_AUTHORITY || ""
export const redirectUri = process.env.REACT_APP_REDIRECT_URI || ""
export const scopes = [process.env.REACT_APP_SCOPES || ""]
export const baseURL = process.env.REACT_APP_BASE_URL_BACKEND || ""
export const logAcessoBaseURL = process.env.REACT_APP_LOG_ACESSO_BASE_URL || ""
export const logAcessoNomeSolucao = process.env.REACT_APP_LOG_ACESSO_NOME_SOLUCAO || ""
